import React from "react";
import { Add } from "@mui/icons-material";
import { HeaderButton } from "../button/HeaderButton";
import { ComponentType } from "../../constants";
import { useComponentTemplateDialog } from "../../contexts/ComponentTemplateDialogContext";
import { ComponentTemplateDto } from "@growth-machine-llc/stridist-api-client";
import { JourneyAnchors } from "../../constants";
import {
  Box,
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import { ComponentTypesAssets } from "../program/filters/ComponentTypeFilter";
import { getContentType } from "../../utils/component";
import makeStyles from "@mui/styles/makeStyles";
import { colorSystem } from "../../theme";

const useStyles = makeStyles((theme) => ({
  itemIcon: {
    height: theme.spacing(5),
    width: theme.spacing(5),
    backgroundColor: colorSystem.secondaryGray,
    borderRadius: theme.spacing(0.5),
    marginRight: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  primaryText: {
    fontSize: 14,
    fontWeight: "bold",
    textTransform: "uppercase",
  },

  secondaryText: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
}));

export interface CreateComponentTemplateButtonProps {
  disabled?: boolean;
  className?: string;
  useThemePalette?: boolean;
  children?: React.ReactNode;
}

const AVAILABLE_COMPONENT_TYPES = Object.entries(ComponentTypesAssets).filter(
  ([type]) => type !== ComponentType.MESSAGE,
);

export function CreateComponentTemplateButton(
  props: CreateComponentTemplateButtonProps,
) {
  const s = useStyles();
  const { disabled, className, useThemePalette, children } = props;
  const { openDialog } = useComponentTemplateDialog();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleSelectType = (type: ComponentType) => {
    handleCloseMenu();

    openDialog(
      ComponentTemplateDto.fromJS({
        title: "",
        content: "[]",
        type,
        habitPrompt: "",
        image: "",
      }),
    );
  };

  return (
    <Box className={JourneyAnchors.COMPONENT_TEMPLATE_ADD_BUTTON}>
      <HeaderButton
        startIcon={<Add />}
        onClick={handleOpenMenu}
        disabled={disabled}
        className={className}
        useThemePalette={useThemePalette}
      >
        {children}
      </HeaderButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {AVAILABLE_COMPONENT_TYPES.map(([type, asset], index) => (
          <React.Fragment key={type}>
            <MenuItem
              key={type}
              onClick={() => handleSelectType(type as ComponentType)}
            >
              <ListItemIcon className={s.itemIcon}>{asset.icon}</ListItemIcon>
              <ListItemText
                primary={getContentType(type as ComponentType)}
                secondary={asset.description}
                classes={{
                  primary: s.primaryText,
                  secondary: s.secondaryText,
                }}
              />
            </MenuItem>
            {index !== AVAILABLE_COMPONENT_TYPES.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </Menu>
    </Box>
  );
}
